/** student/sessions — API. */
import { http } from '../../_shared/http';
import type { MySessionsResponse, LaunchStudentSessionResponse } from './types';

export const studentSessionsApi = {
  fetchMySessions: () => http.get<MySessionsResponse>('/world-sessions/my-sessions'),

  /** Creates/reuses the Nakama match and returns a game-client launch URL. */
  launchSession: (sessionId: string) =>
    http.post<LaunchStudentSessionResponse>(`/world-sessions/my-sessions/${sessionId}/launch`),
};
